export enum DataHeapId {
    myTicketsQuestionsPageSubmit = 'My Tickets - Questions Page - Click - Submit',
    multiticketCTAClick = 'ListingWeb - Multiticket CTA - Click - CTA',
}

export enum HeapPageArea {
    purchaseConfirmationPage = 'checkout-confirmation',
}
